<ion-grid>
  <ion-row class="ion-justify-content-center">
    <ion-avatar class="avatar-image">
      @if (imageUrl) {
      <img alt="Player Image" [src]="imageUrl" />
      } @else {
      <img [src]="avatarImage" />
      <ion-fab class="upload-image-icon">
        @if(isMobile){
        <ion-fab-button size="small" (click)="takePicture()">
          <ion-icon name="camera-outline"></ion-icon>
        </ion-fab-button>
        }@else {
        <ion-fab-button size="small" (click)="takePicture()">
          <ion-icon name="cloud-upload-outline"></ion-icon>
        </ion-fab-button>
        }
      </ion-fab>
      }
    </ion-avatar>
  </ion-row>
  @if (!imageUrl) {
  <ion-row class="ion-justify-content-center supported-file-formate">
    <small>{{'Supported file formate png/jpeg/jpg/heic' | translate}}</small> </ion-row
  >}
</ion-grid>

<ion-buttons class="ion-float-right clear-image" *ngIf="imageUrl">
  <ion-button color="danger" fill="clear" (click)="clearImage()">
    {{'Clear Image' | translate}}
  </ion-button>
</ion-buttons>

<div class="upload-container">
  <input
    type="file"
    accept="image/*"
    (change)="onFileSelected($event)"
    style="display: none"
  />
</div>

<ion-modal [isOpen]="isModalOpen" backdropDismiss="false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{'Crop Image' | translate}}</ion-title>
        <ion-buttons slot="end">
          <ion-button
            color="dark"
            fill="clear"
            (click)="setOpen(false); close()"
          >
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div *ngIf="!isMobile">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [roundCropper]="true"
          [aspectRatio]="1 / 1"
          format="png"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
      </div>

      <div *ngIf="imageBase64">
        <image-cropper
          [imageBase64]="imageBase64"
          [maintainAspectRatio]="true"
          [roundCropper]="true"
          [aspectRatio]="1 / 1"
          format="png"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>
      </div>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <div class="btn-center">
          <ion-button
            class="btn-size"
            expand="block"
            shape="round"
            (click)="saveImage()"
          >
            {{'Save Image' | translate}}
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
